import {createModel} from "@rematch/core";

export type DownloadStatus = "pending" | "ready" | "error";

export type DownloadEntry = {
  id: string;
  label: string;
  status: DownloadStatus;
  error?: string;
};

type State = {
  downloads: DownloadEntry[];
};

const initialState: State = {
  downloads: [],
};

let _nextId = 0;

export const model = createModel({
  name: "downloadManager",

  state: initialState,

  reducers: {
    _add(state: State, entry: DownloadEntry): State {
      return {...state, downloads: [...state.downloads, entry]};
    },

    _updateStatus(
      state: State,
      payload: {id: string; status: DownloadStatus; error?: string},
    ): State {
      return {
        ...state,
        downloads: state.downloads.map(d =>
          d.id === payload.id
            ? {...d, status: payload.status, error: payload.error}
            : d,
        ),
      };
    },

    remove(state: State, id: string): State {
      return {...state, downloads: state.downloads.filter(d => d.id !== id)};
    },
  },

  effects: (dispatch: any) => ({
    async start({label, fn}: {label: string; fn: () => Promise<void>}) {
      const id = String(++_nextId);
      dispatch.downloadManager._add({id, label, status: "pending"});

      try {
        await fn();
        dispatch.downloadManager._updateStatus({id, status: "ready"});
        setTimeout(() => dispatch.downloadManager.remove(id), 5000);
      } catch (error) {
        dispatch.downloadManager._updateStatus({
          id,
          status: "error",
          error: error instanceof Error ? error.message : "Download failed",
        });
        setTimeout(() => dispatch.downloadManager.remove(id), 10000);
      }
    },
  }),
});
